// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import ProductBlockVertical from '/react4xp/components/ProductBlockVertical'

// prop types
interface NewProductsBannerProps {

    // section props
    section?: {
        bgColor: 'blue' | 'blue-dark' | 'yoghurt'
        noSeparator?: boolean
        paddingTop?: 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'small' | 'medium' | 'big' | 'none'
    }

    // product banner props
    sectionTitle?: string
    howMany: 1 | 2 | 3

    // product card props
    products?: Array<{
        href: string
        external?: boolean
        src: string
        srcMobile: string
        alt?: string
        tilt?: 'left' | 'right'
        hoverTilt?: 'left' | 'right'
        title: string
        desc: string
    }>
}

export default function NewProductsBanner({
    section,
    sectionTitle,
    howMany,
    products
}: NewProductsBannerProps) {
    return (
        <Section
            bgColor={section.bgColor}
            noSeparator={section.noSeparator}
            paddingTop={section.paddingTop}
            paddingBottom={section.paddingBottom}
            className='new-products-banner two-products'
        >
            <div className='container'>

                {sectionTitle && (
                    <h2 className={clsx(
                        'section-title',
                        section.bgColor === 'yoghurt' && 'blue-dark',
                        section.bgColor === 'blue' && 'white',
                        section.bgColor === 'blue-dark' && 'white'
                    )}>
                        {sectionTitle}
                    </h2>
                )}

                <div className='row'>
                    
                    {howMany === 1 && products && products.length > 0 && (
                        <div className='col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3'>
                            <ProductBlockVertical
                                blockSize='large'
                                href={products[0].href}
                                external={products[0].external}
                                src={products[0].src}
                                srcMobile={products[0].srcMobile}
                                alt={products[0].alt}
                                width={700}
                                sizes='(max-width: 480px) 100vw, (max-width: 768px) 50vw, 700px'
                                tilt={products[0].tilt}
                                hoverTilt={products[0].hoverTilt}
                                title={products[0].title}
                                desc={products[0].desc}
                            />
                        </div>
                    )}

                    {howMany === 2 && products && products.length >= 2 && (
                        <div className='col-xl-10 offset-xl-1'>
                            <div className='row'>
                                {products && products.map((item, i) => (
                                    <div className='col-md-6 col-xl-5' key={i}>
                                        <ProductBlockVertical
                                            blockSize='medium'
                                            href={item.href}
                                            external={item.external}
                                            src={item.src}
                                            srcMobile={item.srcMobile}
                                            alt={item.alt}
                                            width={400}
                                            sizes='(max-width: 480px) 100vw, (max-width: 768px) 50vw, 400px'
                                            tilt={item.tilt}
                                            hoverTilt={item.hoverTilt}
                                            title={item.title}
                                            desc={item.desc}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {howMany === 3 && products && products.length >= 3 && (
                        products && products.map((item, i) => (
                            <div className='col-md-4' key={i}>
                                <ProductBlockVertical
                                    blockSize='small'
                                    href={item.href}
                                    external={item.external}
                                    src={item.src}
                                    srcMobile={item.srcMobile}
                                    alt={item.alt}
                                    width={300}
                                    sizes='(max-width: 480px) 100vw, (max-width: 768px) 50vw, 300px'
                                    tilt={item.tilt}
                                    hoverTilt={item.hoverTilt}
                                    title={item.title}
                                    desc={item.desc}
                                />
                            </div>
                        ))
                    )}

                </div>

            </div>
        </Section>
    )
}